// extracted by mini-css-extract-plugin
export default {"title":"DeleteOrg_title__yk9W-"};